/**
 * module for map entries
 *
 * Map entries are layer available on a map, for searching, or view.
 * They can be grouped in a [[GroupMapEntry]]
 *
 * @module geo/map/layer
 * @since v 2.0.1
 * @preferred
 */

import {Store} from 'redux';
import {Observable} from 'rxjs/Observable';
import {fromPromise} from 'rxjs/observable/fromPromise';
import {isUndefined} from 'util';

import {setEntriesVisibilityCreatorP} from '../../actions/creators';
import {AppStore} from '../../store/app';
import {Entry} from '../../types/map/entry';
import {IHashEntry} from '../../types/map/layer/map.entry';

/**
 * Common class for all  map entries
 */
export class MapEntry implements Entry {
  /**
   * static type of class of map entry (e.g VectorLayerMapEntry )
   * @private
   */
  public static typeDef: string;
  /**
   * full pas of the ressource ( with group etc, like
   * "51ad22a0-26e0-4eea-a05b-e62ac5f37b2b.entries.7c21423a-f227-11e7-92cb-71fa4a4e0bee")
   * can be used for listen specific entry in map object
   */
  public fullPath: string;
  /**
   * internal id of entry
   */
  public key: string;
  /**
   * name of layer entry in legend
   */
  public name: string;
  /**
   * current type of map entry (e.g VectorLayerMapEntry )
   *
   */
  public '@type': string;
  /**
   * is the entry visible in legend?
   */
  public legendVisible?: boolean;
  /**
   * is the entry visible at application startup
   */
  public initiallyVisible?: boolean;
  /**
   * Sub entries of current entry
   */
  public entries: IHashEntry;
  /**
   * if entry has subentry, indicate if details are shown
   */
  public legendVisibleDetails?: boolean;
  /**
   * true if layer is available and visible on map
   */
  public visible?: boolean;
  /**
   * Store of entry
   * @private
   */
  public store: Store<AppStore>;
  [key: string]: any;

  constructor(options: any, store: Store<AppStore>) {
    Object.assign(this, options);
    if (isUndefined(options)) {
      throw new Error('undefined options');
    }
    if (isUndefined(options.key)) {
      throw new Error('undefined options.key');
    }
    this.key = options.key;
    if (!isUndefined(options.fullPath)) {
      this.fullPath = options.fullPath;
    } else {
      this.fullPath = '';
    }
    if (!isUndefined(options.name)) {
      this.name = options.name;
    } else {
      this.name = '';
    }
    if (!isUndefined(options.entries)) {
      this.entries = options.entries;
    } else {
      this.entries = {};
    }
    this.store = store;
  }

  /**
   * Is entry of type of the class
   * @param entry entryobj to test
   * @param classEntry class VectorLayerMapEntry or GroupMapEntry
   */
  public static isOfType(entry: Entry, classEntry: any): boolean {
    return classEntry.typeDef === entry['@type'];
  }

  /**
   * Set the visibility of the MapEntry.
   * @param visibility
   */
  public setVisibility(visibility: boolean): Observable<any> {
    return fromPromise(setEntriesVisibilityCreatorP(
        {entries: [{key: this.key, visible: visibility}]},
        this.store.dispatch));
  }
}

/**
 * an hash map of layers, ordered by key
 */
export interface HashMapEntry {
  [key: string]: MapEntry;
}
/**
 * an hash map of layers visibility, ordered by key
 */
export interface HashMapEntryVisibility {
  [key: string]: boolean;
}
